import { useBusinessSettings } from '@/hooks/settings/useBusinessSettings';

/**
 * The company's IANA timezone (`BusinessSettings.timezone`) — the canonical
 * fallback for formatting a business timestamp when the entity (job /
 * appointment / invoice) doesn't carry its own `timezone` in the payload.
 *
 * Per SPEC-tz-0: documents render in the company tz; scheduled events in the
 * entity tz (fallback company tz). Never the viewer's browser tz. Pass the
 * result to `formatDateTimeInTimeZone(value, tz)`.
 */
export function useCompanyTimezone(): string | undefined {
  const { data } = useBusinessSettings();
  return data?.timezone || undefined;
}
